import { render } from "./ProjectReport.vue?vue&type=template&id=f13f2d04&scoped=true"
import script from "./ProjectReport.vue?vue&type=script&lang=js"
export * from "./ProjectReport.vue?vue&type=script&lang=js"

import "./ProjectReport.vue?vue&type=style&index=0&id=f13f2d04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f13f2d04"]])

export default __exports__